import { AppState } from 'app-store'
import { getLocationState } from '@common/state/selectors'
import { BuyFormatCurrencyState } from './state'

export const mapBuyFormatCurrencyState = (state: AppState): BuyFormatCurrencyState => {
    const { locationInfo } = getLocationState(state)
    const { locale: Locale, currency: CurrencyCode } = locationInfo
    return {
        Locale,
        CurrencyCode,
    }
}

export const mapBuyFormatCurrencyActions = {}

export type BuyFormatCurrencyActionsType = typeof mapBuyFormatCurrencyActions
